module.exports = __webpack_public_path__ + "packs/media/images/badges/boulderista-a6251853b02ce5faad502f86bcc34c17.png";